import http from "../../utils/httpClient";
class refundService {
  postRefundData = async (data) => {
    return await http.post(`/api/Payment/CreateCustomerRefund`, data);
  };
  fetchRefundedData = async (query) => {
    return await http.get(
      `/api/Payment/GetPaymentCustomerRefund`, { params: query }
    );
  };
}
export default new refundService();
